// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "babel-polyfill";
import Vue from "vue";
import App from "./App";
import router from "./router";
import moment from "moment";
import xiaomaolv from "./config/xiaomaolv";
import duoduo from "./config/duoduo";
Vue.prototype.xiaomaolv = xiaomaolv;
Vue.prototype.duoduo = duoduo;
// 时间计算
Vue.prototype.$moment = moment;
// axios.defaults.timeout = 5000;
// axios.defaults.withCredentials=true;
import axios from "axios";
var baseURL, opsBaseURL;

if (window.location.host == "bimp.console.detu.com") {
  sessionStorage.setItem('Global',JSON.stringify(xiaomaolv))
  sessionStorage.setItem('switchhost', 'true')
  baseURL = "//bimp.donkeysgo.com/";
  opsBaseURL = "//bimp.donkeysgo.com/";
  Vue.prototype.$serverUrl = "//bimp.donkeysgo.com/";
} else if (window.location.host.startsWith("bimp.test.console.donkeysgo.com")) {
  sessionStorage.setItem('Global',JSON.stringify(xiaomaolv))
  sessionStorage.setItem('switchhost', 'true')
  baseURL = "//supervision.test.detu.com/";
  opsBaseURL = "//supervision.test.detu.com/";
  Vue.prototype.$serverUrl = "//supervision.test.detu.com/";
} else if (window.location.host.startsWith("bimp.test.console.detu.com")) {
  sessionStorage.setItem('Global',JSON.stringify(xiaomaolv))
  sessionStorage.setItem('switchhost', 'true')
  baseURL = "//supervision.test.detu.com/";
  opsBaseURL = "//supervision.test.detu.com/";
  Vue.prototype.$serverUrl = "//supervision.test.detu.com/";
} else if (window.location.host.startsWith("supervision.console.detu.com")) {
  sessionStorage.setItem('Global',JSON.stringify(xiaomaolv))
  sessionStorage.setItem('switchhost', 'true')
  baseURL = "//supervision.detu.com/";
  opsBaseURL = "//supervision.detu.com/";
  Vue.prototype.$serverUrl = "//supervision.detu.com/";
} else if (window.location.host.startsWith("bimp.console.dev.donkeysgo.com")) {
  sessionStorage.setItem('Global',JSON.stringify(xiaomaolv))
  sessionStorage.setItem('switchhost', 'true')
  baseURL = "//supervision.test.detu.com/";
  opsBaseURL = "//supervision.test.detu.com/";
  // opsBaseURL = "http://192.168.8.31:33305";
  Vue.prototype.$serverUrl = "//supervision.test.detu.com/";
} else if (window.location.host.startsWith("bimp.gh.console.detu.com")) {
  sessionStorage.setItem('Global',JSON.stringify(xiaomaolv))
  sessionStorage.setItem('switchhost', 'true')
  baseURL = "//bimp.gh.detu.com/";
  opsBaseURL = "//bimp.gh.detu.com/";
  // opsBaseURL = "http://192.168.8.31:33305";
  Vue.prototype.$serverUrl = "//bimp.gh.detu.com/";
} else if (window.location.host.startsWith("ys.console.detu.com")) {
  sessionStorage.setItem('Global',JSON.stringify(xiaomaolv))
  sessionStorage.setItem('switchhost', 'true')
  opsBaseURL = "//ys.bimp.detu.com/";
  Vue.prototype.$serverUrl = "//ys.bimp.detu.com/";
} else if (window.location.host.startsWith("supv-yc.console.detu.com")) {
  sessionStorage.setItem('Global',JSON.stringify(xiaomaolv))
  sessionStorage.setItem('switchhost', 'true')
  opsBaseURL = "//supv-yc.detu.com/";
  Vue.prototype.$serverUrl = "//supv-yc.detu.com/";
} else {
  alert("域名不对");
}
// axios.defaults.baseURL = 'http://192.168.8.204/'
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
// if(sessionStorage.getItem('token')){
//     axios.defaults.headers.common['auth'] = sessionStorage.getItem('token');
// }



// var token = sessionStorage.getItem('token')
// console.log("token"+token);
Vue.prototype.$axios = axios.create({
  baseURL: baseURL,
  timeout: 20000,
  headers: {
    post: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    common: {
      auth: sessionStorage.getItem("token"),
    },
  },
});

Vue.prototype.$axios.interceptors.response.use(
  (response) => {
    // 如果返回的状态码为200，说明接口请求成功，可以正常拿到数据
    // 否则的话抛出错误
    // console.log("response.data");
    if (response.status === 200) {
      // console.log(response.data)
      if (response.data && response.data.code == "77777") {
        // console.log("re")
        router.push({ path: "/login" });
        return;
      }
      return Promise.resolve(response);
    } else {
      return Promise.reject(response);
    }
  },
  (error) => {
    if (error == "Error: Network Error") {
      Message.error("网络错误！");
      return false;
    }
    return Promise.reject(error.response);
  }
)






// console.log(sessionStorage.getItem("token"))
Vue.prototype.$opsaxios = axios.create({
  baseURL: opsBaseURL,
  timeout: 20000,
  headers: {
    post: {
      "Content-Type": "application/json",
    },
    common: {
      MemberAuthorization: sessionStorage.getItem("token"),
    },
  },
});
Vue.prototype.$opsaxios.interceptors.request.use(
  (config) => {
    config.url = config.url + '?rand=' + Date.now() + '_' + Math.random();
    return config
  },
  error => {
    return Promise.reject(error)
  }
)
Vue.prototype.$opsaxios.interceptors.response.use(
  (response) => {
    // 如果返回的状态码为200，说明接口请求成功，可以正常拿到数据
    // 否则的话抛出错误
    // console.log("response.data");
    if (response.status === 200) {
      // console.log(response.data)
      if (response.data && response.data.code == "-1003") {
        // console.log("re")
        router.push({ path: "/login" });
        return;
      }
      return Promise.resolve(response);
    } else {
      return Promise.reject(response);
    }
  },
  (error) => {
    if (error == "Error: Network Error") {
      Message.error("网络错误！");
      return false;
    }
    return Promise.reject(error.response);
  }
);
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
Vue.use(ElementUI);
Vue.config.debug = true;
Vue.config.productionTip = false;
Vue.prototype.FrontVersion = window.GlobalFrontVersion

// 加载XLSX
import XLSX from 'xlsx';
Vue.use(XLSX);

// 加载富文本编辑器
import VueQuillEditor from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
Vue.use(VueQuillEditor);
/* eslint-disable no-new */

router.beforeEach((to, from, next) => {
  if (to.name == "carDetails") {
    //   if(from.name == "车辆管理"){
    //     to.meta.keepAlive = false;
    //   }else{
    //     to.meta.keepAlive = true;
    //   }
  }
  next();
});

new Vue({
  el: "#app",
  router,
  components: { App },
  template: "<App/>",
});



// WEBPACK FOOTER //
// ./src/main.js